import * as React from 'react';
export const blikSvg = React.forwardRef(function blikSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#010101',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.276 13.305a6.268 6.268 0 0 0-2.968.745v-7.1H10v12.629a6.277 6.277 0 0 0 12.553 0 6.275 6.275 0 0 0-6.277-6.274Zm0 9.295a3.021 3.021 0 1 1 0-6.042 3.021 3.021 0 0 1 0 6.042Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.592 11.921a2.96 2.96 0 1 0 0-5.921 2.96 2.96 0 0 0 0 5.921Z',
      fill: 'url(#bi_blik__a)',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_blik__a',
          x1: 103.397,
          y1: 92.918,
          x2: 521.926,
          y2: 511.447,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E52F08',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#E94F96',
        }),
      ),
    ),
  );
});
blikSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var blik = {
  category: 'brand',
  colorable: false,
  name: 'blik',
  svg: blikSvg,
};
